export { default } from './StockCarCardSkeleton';
